/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_SwitchingInputs */

const en_read_along_ai_switching = /** @type {(inputs: Read_Along_Ai_SwitchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trying the other model…`)
};

const es_read_along_ai_switching = /** @type {(inputs: Read_Along_Ai_SwitchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probando el otro modelo…`)
};

/**
* | output |
* | --- |
* | "Trying the other model…" |
*
* @param {Read_Along_Ai_SwitchingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_switching = /** @type {((inputs?: Read_Along_Ai_SwitchingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_SwitchingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_switching(inputs)
	return en_read_along_ai_switching(inputs)
});